import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { genCssVarRowGap } from './utils.js';

var styles = {"grid-row":"magritte-grid-row___3Zugo_2-2-17","gridRow":"magritte-grid-row___3Zugo_2-2-17"};

const GridRow = forwardRef(({ children, rowGap, ...props }, ref) => {
    const cssVar = genCssVarRowGap({ rowGap });
    return (jsx("div", { ...props, className: styles['grid-row'], style: cssVar, ref: ref, children: children }));
});
GridRow.displayName = 'GridRow';

export { GridRow };
//# sourceMappingURL=Row.js.map
